import React from "react";
import CommonDesignSection from "./design/CommonDesignSection";
import HeroDesignSection from "./design/HeroDesignSection";
import FeaturesDesignSection from "./design/FeaturesDesignSection";
import TestimonialsDesignSection from "./design/TestimonialsDesignSection";
import GalleryDesignSection from "./design/GalleryDesignSection";
import CTADesignSection from "./design/CTADesignSection";
import ServiceDesignSection from "./design/ServiceDesignSection";
import LocationDesignSection from "./design/LocationDesignSection";
import CategoryDesignSection from "./design/CategoryDesignSection";

export default function DesignTab({
  editedSection,
  t,
  flags,
  alignmentValue,
  setAlignment,
  onStyleChange,
}) {
  return (
    <div className="space-y-4">
      <CommonDesignSection
        editedSection={editedSection}
        t={t}
        flags={flags}
        alignmentValue={alignmentValue}
        setAlignment={setAlignment}
        onStyleChange={onStyleChange}
      />

      <HeroDesignSection
        editedSection={editedSection}
        t={t}
        flags={flags}
        onStyleChange={onStyleChange}
      />

      <FeaturesDesignSection
        editedSection={editedSection}
        t={t}
        flags={flags}
        onStyleChange={onStyleChange}
      />

      <TestimonialsDesignSection
        editedSection={editedSection}
        t={t}
        flags={flags}
        onStyleChange={onStyleChange}
      />

      <GalleryDesignSection
        editedSection={editedSection}
        t={t}
        flags={flags}
        onStyleChange={onStyleChange}
      />

      <CategoryDesignSection
        editedSection={editedSection}
        t={t}
        flags={flags}
        onStyleChange={onStyleChange}
      />

      <LocationDesignSection
        editedSection={editedSection}
        t={t}
        flags={flags}
        onStyleChange={onStyleChange}
      />

      <ServiceDesignSection
        editedSection={editedSection}
        t={t}
        flags={flags}
        onStyleChange={onStyleChange}
      />

      <CTADesignSection
        editedSection={editedSection}
        t={t}
        flags={flags}
        onStyleChange={onStyleChange}
      />
    </div>
  );
}